import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { APIService } from '../shared/service/api.service';
import { FormularioService } from './form.service';
import { ScriptsService } from '../shared/service/scripts.service';

@Component({
  selector: 'app-sugestoes',
  templateUrl: './sugestoes.component.html',
  styleUrls: ['./sugestoes.component.scss'],
})
export class SugestoesComponent implements OnInit {
  formulario: FormGroup;
  localAlteracao: string[];
  camposCurso: { label: string; fields: any; checkbox: string }[];
  cursos: any;
  eixos: any;
  textoTermo: string;
  resposta: any;
  display: string[] = [];
  regexEmail: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  formErro = false;
  mostarPopUp = false;
  erro = false;
  qtdCamposAdicionados = 0;
  enviouFormulario = false;
  formularioRecebido = false;

  placeHolder: string;
  isDropdownAbertoEixo: boolean;
  isDropdownAbertoSugestao: boolean;
  isDropdownAbertoCurso: boolean;

  constructor(
    private api: APIService,
    private formService: FormularioService,
    private scriptsService: ScriptsService,
  ) {
    scriptsService.load('reCaptcha');
  }

  ngOnInit(): void {
    const { localAlteracao, camposCurso, textoTermo } = this.formService.getFormFields();

    this.camposCurso = camposCurso;
    this.localAlteracao = localAlteracao;
    this.textoTermo = textoTermo;

    this.gerarFormulario();

    this.api.getEixos().subscribe((resposta: any) => {
      this.eixos = resposta;
    });

    this.formulario.get('eixoTecnologicoCncstId').valueChanges.subscribe((eixoId) => {
      if (eixoId) {
        this.api.getCursosNaoPaginado(eixoId).subscribe(response => {
          this.cursos = response;
        });
      }
    });

    // adiciona os campos do curso no formulário
    this.camposCurso.forEach((campo) => {
      this.formulario.addControl(campo.fields.proposta, new FormControl(null, Validators.maxLength(5000)));
      this.formulario.addControl(campo.fields.justificativa, new FormControl(null, Validators.maxLength(5000)));
    });
  }

  gerarFormulario(): void {
    this.formulario = new FormGroup({
      nome: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      email: new FormControl(null, [Validators.pattern(this.regexEmail), Validators.maxLength(100)]),
      instituicaoEmpresa: new FormControl(null, [Validators.maxLength(150)]),
      sugestaoPara: new FormControl(null, [Validators.required]),
      propostaApresentacaoCatalogo: new FormControl(null, Validators.maxLength(5000)),
      justificativaApresentacaoCatalogo: new FormControl(null, Validators.maxLength(5000)),
      eixoTecnologicoCncstId: new FormControl('', Validators.required),
      cursoCncstId: new FormControl(''),
      propostaEixo: new FormControl(null, Validators.maxLength(5000)),
      justificativaEixo: new FormControl(null, Validators.maxLength(5000)),
      aceitaTermo: new FormControl(false, Validators.requiredTrue),
      reCaptcha: new FormControl(null, [Validators.required]),
    });
  }

  verificaSelecaoDaSugestao(selecao: string): void {
    if (selecao === 'Eixo tecnológico') {
      this.adicionaValidadorCampoRequerido(['propostaEixo', 'justificativaEixo']);
      this.limpaValidadores(['cursoCncstId', 'propostaApresentacaoCatalogo', 'justificativaApresentacaoCatalogo']);

      this.camposCurso.forEach(campo => {
        this.limpaValidadores([campo.fields.proposta]);
        this.limpaValidadores([campo.fields.justificativa]);
      });
    }

    if (selecao === 'Curso') {
      this.adicionaValidadorCampoRequerido(['cursoCncstId']);
      this.limpaValidadores([
        'propostaEixo',
        'justificativaEixo',
        'propostaApresentacaoCatalogo',
        'justificativaApresentacaoCatalogo',
      ]);
    }

    if (selecao === 'Apresentação do Catálogo (novo formato)') {
      this.adicionaValidadorCampoRequerido(['propostaApresentacaoCatalogo', 'justificativaApresentacaoCatalogo']);
      this.limpaValidadores([
        'cursoCncstId',
        'propostaEixo',
        'justificativaEixo',
        'eixoTecnologicoCncstId'
      ]);

      this.formulario.get('eixoTecnologicoCncstId').setValue(0);
      this.formulario.get('eixoTecnologicoCncstId').markAsDirty();
      // this.formulario.get('eixoTecnologicoCncstId').markAsTouched();

      this.camposCurso.forEach(campo => {
        this.limpaValidadores([campo.fields.proposta]);
        this.limpaValidadores([campo.fields.justificativa]);
      });
    }
  }

  adicionaValidadorCampoRequerido(campos: string[]) {
    campos.forEach((campo) => {
      this.formulario.get(campo).reset();
      this.formulario.controls[campo].setValidators([Validators.required, Validators.maxLength(5000)]);
      this.formulario.controls[campo].updateValueAndValidity();
    });
  }

  limpaValidadores(campos: string[]) {
    campos.forEach((campo) => {
      this.formulario.controls[campo].clearValidators();
      this.formulario.controls[campo].updateValueAndValidity();
      this.formulario.get(campo).reset();
    });
  }

  add() {
    this.qtdCamposAdicionados = this.qtdCamposAdicionados + 1;
  }

  sub() {
    this.qtdCamposAdicionados = this.qtdCamposAdicionados - 1;
  }

  cancelar() {
    if (this.formularioRecebido) {
      window.location.reload();
      return;
    }
    this.mostarPopUp = false;
  }

  onSubimitFormulario(): void {
    this.erro = false;
    this.formErro = false;
    this.enviouFormulario = true;

    if (this.formulario.invalid) {
      this.formulario.markAllAsTouched();
      this.formErro = true;
      setTimeout(() => {
        this.enviouFormulario = false;
      }, 300);
      return;
    }

    // Confere se todos os campos do curso foram preenchidos.
    if (this.formulario.get('sugestaoPara').value === 'Curso') {
      if (this.qtdCamposAdicionados === 0) {
        this.formulario.setErrors({ nenhumCampoAdicionado: true });
        this.formErro = true;
        setTimeout(() => {
          this.enviouFormulario = false;
        }, 200);
        return;
      }
    }

    const url = window.location.href;
    const form = { ...this.formulario.value, linkFormulario: url };
    this.mostarPopUp = true;

    this.formService.postForm(form).subscribe((resp) => {
      setTimeout(() => {
        this.resposta = resp;
        this.formulario.reset();
        // Adicione esta linha para garantir que o reCAPTCHA não esteja 'touched'
        this.formulario.get('reCaptcha').markAsUntouched();
        this.formularioRecebido = true;
        this.enviouFormulario = false; // <-- adicione isso aqui
      }, 300);
    },
      (erro) => {
        this.erro = erro;
        this.enviouFormulario = false; // Também resetar em caso de erro para permitir nova tentativa
      },
    );
  }

  /**
   *
   * @param tipo Tipo do combo para a abertura de dropown.
   */
  toggleDropdown(tipo: any) {
    this.isDropdownAbertoEixo = tipo === 'eixo' ? !this.isDropdownAbertoEixo : false;
    this.isDropdownAbertoCurso = tipo === 'curso' ? !this.isDropdownAbertoCurso : false;
    this.isDropdownAbertoSugestao = tipo === 'sugestao' ? !this.isDropdownAbertoSugestao : false;
  }

  /**
   * Função para obter o nome do eixo, sugestão e curso selecionado.
   * @param campo nome do campo
   * @returns valor selecionado
   */
  getNomeSelecionado(campo: any): string {
    if (campo === 'eixo') {
      const eixoId = this.formulario.get('eixoTecnologicoCncstId')?.value;
      if (!eixoId) {
        return '';
      }

      const eixoSelecionado = this.eixos.find((e: any) => e.id === eixoId);
      return eixoSelecionado ? eixoSelecionado.nome : '';

    } // Não tem ID.
    else if (campo === 'sugestao') {
      const sugestao = this.formulario.get('sugestaoPara')?.value;
      if (!sugestao) {
        return '';
      }


      return sugestao;

    }
    else if (campo === 'curso') {
      const cursoId = this.formulario.get('cursoCncstId')?.value;
      if (!cursoId) {
        return '';
      }

      const cursoSelecionado = this.cursos.find((e: any) => e.id === cursoId);
      return cursoSelecionado ? cursoSelecionado.nome : '';
    }
  }

  /**
   *  Função para manipular a seleção do combo.
   *
   * @param campo nome do campo
   * @param valor valor do campo
   * @param event valor do evento
   */
  onSelecionado(campo: any, valor: any, event?: Event): void {

    if (event) {
      event.stopPropagation(); // Evita múltiplas chamadas se propagando
    }

    if (campo === 'eixo') {
      // Atualiza o valor no formulário
      this.formulario.get('eixoTecnologicoCncstId')?.setValue(valor.id);
      this.formulario.get('eixoTecnologicoCncstId').markAsDirty();
      // this.formulario.get('eixoTecnologicoCncstId').markAsTouched();
      // Fecha o dropdown após seleção
      this.isDropdownAbertoEixo = false;
    }
    else if (campo === 'sugestao') {
      // Atualiza o valor no formulário
      this.formulario.get('sugestaoPara')?.setValue(valor);
      this.formulario.get('sugestaoPara').markAsDirty();
      this.formulario.get('sugestaoPara').markAsTouched();

      this.verificaSelecaoDaSugestao(valor);

      // Fecha o dropdown após seleção
      this.isDropdownAbertoSugestao = false;
    }
    else if (campo === 'curso') {
      // Atualiza o valor no formulário
      this.formulario.get('cursoCncstId')?.setValue(valor.id);
      this.formulario.get('cursoCncstId').markAsDirty();
      // this.formulario.get('cursoCncstId').markAsTouched();
      // Fecha o dropdown após seleção
      this.isDropdownAbertoCurso = false;
    }
  }

  /**
   *  Função Limpar.
   */
  limparFiltro() {
    this.formulario.reset(); // Limpa campos
  }

  /**
   *
   * @param event evento de click.
   */
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const dentroDeElementoPermitido = this.temParentElement(event.target, ['br-input', 'br-button']);

    // Se o clique foi dentro de um dropdown, não fecha lista.
    if (dentroDeElementoPermitido) {
      return;
    }

    // Se o clique foi fora de um dropdown, fecha lista.
    this.isDropdownAbertoCurso = false;
    this.isDropdownAbertoEixo = false;
    this.isDropdownAbertoSugestao = false;
  }

  /**
   * @param target elementos do documento.
   * @param classesPermitidas classes de estilos.
   * @returns true ou false.
   */
  temClassePermitida(target: EventTarget, classesPermitidas: string[]): boolean {
    if (target instanceof HTMLElement) {
      return classesPermitidas.some(classe => target.classList.contains(classe));
    }
    return false;
  }

  temParentElement(target: EventTarget, classesPermitidas: string[]): boolean {
    if (target instanceof HTMLElement && target.parentElement) {
      const parentElement = target.parentElement;
      return classesPermitidas.some(classe => parentElement.classList.contains(classe));
    }
    return false;
  }

  /**
   * @param target elementos do documento.
   * @returns true ou false.
   */
  estaDentroDeDropdown(target: EventTarget): boolean {
    const dropdowns = document.querySelectorAll('.br-list[expanded]');
    return Array.from(dropdowns).some(dropdown => dropdown.contains(target as Node));
  }

}
